import { render, staticRenderFns } from "./stored-value-config.vue?vue&type=template&id=814f4756"
import script from "./stored-value-config.vue?vue&type=script&lang=js"
export * from "./stored-value-config.vue?vue&type=script&lang=js"
import style0 from "./stored-value-config.vue?vue&type=style&index=0&id=814f4756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports